// extracted by mini-css-extract-plugin
module.exports = {"container":"Subscribe_container__10iOl","subtitle":"Subscribe_subtitle__3Xzv3","form":"Subscribe_form__K_v-W","info":"Subscribe_info__3e21Q"};